'use strict';

// get the global data layer object
const dataLayer = window.dataLayer || [];

const pushDataLayerEvent = (eventObject) => {
    if (!eventObject) {
        return;
    }

    const executeCallback = function () {
        if (eventObject.eventCallback === undefined || !$.isFunction(eventObject.eventCallback)) {
            return;
        }
        eventObject.eventCallback();
    };

    if (typeof ga === 'undefined' || !window.ga || !ga.create) {
        /* eslint-disable-line */ //If analytics have been disabled, just execute the callback
        executeCallback();
    }

    try {
        dataLayer.push(eventObject);
    } catch (error) {
        console.log('GTM event push failed');
        executeCallback();
    }
};

module.exports = pushDataLayerEvent;
